import React from 'react';
import doctor from '../../../images/doctor-short.png'
const DoctorsCard = () => {
    return (
        <div className='col-md-4 text-center'>
            <div>
                <img style={{height:'250px'}} className='img-fluid' src={doctor} alt="" />
                <h4>Dr. Caudi</h4>
                <p>+6181245756</p>
            </div>
        </div>
    );
};

export default DoctorsCard;